import client from '@/lib/axios-client'
import type { ResolvedBadge, VirtualBadgeToken } from '@/types'

const VIRTUAL_BADGE_URL = '/virtual-badge'

export async function getMyBadgeToken(): Promise<VirtualBadgeToken> {
	const response = await client.get(`${VIRTUAL_BADGE_URL}/me/token`)
	return response.data.data
}

export async function resolveBadge(qrValue: string): Promise<ResolvedBadge> {
	const response = await client.post(`${VIRTUAL_BADGE_URL}/resolve`, {
		qrValue,
	})
	return response.data.data
}
